import { render, staticRenderFns } from "./containerWeb.vue?vue&type=template&id=72e0e1ee&scoped=true"
import script from "./containerWeb.vue?vue&type=script&lang=js"
export * from "./containerWeb.vue?vue&type=script&lang=js"
import style0 from "./containerWeb.vue?vue&type=style&index=0&id=72e0e1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0e1ee",
  null
  
)

export default component.exports